import React from 'react';

import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import type { TableColumn } from './types';

interface UploadTableRowProps {
  row: any;
  columns: TableColumn[];
}

const UploadTableRow: React.FC<UploadTableRowProps> = ({ row, columns }) => (
  <TableRow>
    {columns.map((column) => {
      const { CellComponent } = column;
      return CellComponent ? (
        <CellComponent key={column.id} {...row} />
      ) : (
        <TableCell key={column.id}>{row[column.id]}</TableCell>
      );
    })}
  </TableRow>
);

export default UploadTableRow;
